import AccountForm from "./AccountForm";
import * as formViews from "./constants/formViews";

export { formViews };

export default AccountForm;
